import React from 'react';
import { useFormikContext } from 'formik';
import classNames from 'classnames';
import { HiMiniMapPin } from 'react-icons/hi2';
import { useTranslation } from 'react-i18next';

import Error from 'legacy/common/components/wysiwyg-form/Error';
import LocationPicker from 'legacy/common/components/wysiwyg-form/LocationPicker';

import { useOrganization } from '../../../../context/EditOrganizationProvider';
import { EditOrganizationFormValues } from '../../../../types/edit-organization';

const Location = () => {
  const { t } = useTranslation(['organizations']);
  const { values, touched, errors } =
    useFormikContext<EditOrganizationFormValues>();
  const { data } = useOrganization();

  return (
    <div className="flex flex-col align-center mt-4 mb-4 justify-end align-bottom">
      <div
        className={classNames('text-base flex items-center w-full rounded-md', {
          'bg-red-100 p-1': errors.location && touched.location
        })}
      >
        <HiMiniMapPin size={24} className="mr-2 text-neutral-600" />
        <LocationPicker
          name="location"
          className="text-base font-normal w-full bg-transparent placeholder:text-neutral-800"
          locationFieldName="location"
          placeholder={t('form.locationLabel')}
          initialValue={{
            location: values.location,
            coordinates: values.coordinates
          }}
          disabled={data.isSubmitting}
          coordinatesFieldName="coordinates"
          showCurrentLocationButton={false}
        />
      </div>
      {errors.location && touched.location && <Error error={errors.location} />}
    </div>
  );
};

export default Location;
